import React from 'react';
import { Icon, P } from '@fashionnovateam/nova-ui-toolkit';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import { AddTagFormData } from '../types';

type ToggleFieldName =
  | 'fnExclusive'
  | 'fitSample'
  | 'fabricType'
  | 'trimType'
  | 'labelType'
  | 'washColorType'
  | 'pantsAttribute'
  | 'topsAttribute';

interface FormToggleProps {
  name: ToggleFieldName;
  control: Control<AddTagFormData>;
  options: Array<{ label: string; value: string | boolean }>;
  rules?: RegisterOptions<AddTagFormData, ToggleFieldName>;
}

export function FormToggle({ name, control, options, rules }: FormToggleProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className="space-y-1">
          <div className="flex bg-gray-100 border border-gray-200 rounded-md w-fit">
            {options.map((option) => {
              const isSelected = field.value === option.value;
              return (
                <button
                  key={String(option.value)}
                  type="button"
                  className={`m-0.5 p-2 select-none cursor-pointer ${
                    isSelected
                      ? 'bg-white border-gray-200 border rounded-md'
                      : 'border border-transparent'
                  }`}
                  onClick={() => field.onChange(option.value)}
                >
                  <P
                    size="xs"
                    weight="medium"
                    color={isSelected ? 'primary' : 'secondary'}
                  >
                    {option.label}
                  </P>
                </button>
              );
            })}
          </div>
          {fieldState.error && (
            <div className="mt-1 flex items-center gap-1">
              <Icon
                name="alert/alert-circle"
                color="red"
                size="12px"
                variant="stroke"
              />
              <P size="xs" color="error">
                {fieldState.error.message}
              </P>
            </div>
          )}
        </div>
      )}
    />
  );
}
